import type { CityConfig } from "../city-template/types";

export const hampdenConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Maine CDC Vital Records", href: "https://www.maine.gov/dhhs/mecdc/public-health-systems/data-research/vital-records/", description: "Official Maine vital records office in Augusta" },
    { label: "Marriage Licenses — Penobscot County Clerk", href: "https://www.penobscot-county.net/", description: "Penobscot County Clerk — marriage license issuance" },
    { label: "Divorce Records — Penobscot County Clerk", href: "https://www.penobscot-county.net/", description: "Penobscot County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Maine CDC for online vital record orders" },
  ],
  city: "Hampden",
  state: "Maine",
  stateAbbr: "ME",
  slug: "hampden",
  route: "/hampden",
  title: "Emergency Passport Hampden, ME — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Hampden, Maine — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Hampden, Bangor, Winterport, Newburgh, and Penobscot County. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Hampden, ME",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Hampden and greater Bangor area travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Suburban%20Maine%20neighborhood%20with%20classic%20New%20England%20homes%20and%20autumn%20trees%2C%20Penobscot%20County%20countryside%20near%20Bangor%20Maine%20with%20rolling%20green%20hills%20and%20red%20barns%2C%20peaceful%20rural%20residential%20community%20in%20central%20Maine%20with%20mature%20oak%20trees%20and%20well-kept%20lawns%2C%20warm%20afternoon%20sunlight%2C%20professional%20travel%20photography%20style&width=1800&height=700&seq=hampden-me-hero-001&orientation=landscape",
  heroImageAlt: "Hampden Maine suburban neighborhood near Bangor with classic New England homes and countryside",
  geoPosition: "44.7444;-68.8370",
  geoPlacename: "Hampden, Maine",
  lastModified: "2026-06-01",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "5 Custom House St, Boston, MA 02110",
    distance: "Located in Boston — approximately 110 miles (2 hours) from Hampden, ME",
  },
  nearbyCitiesZips: [
    { name: "Hampden", zips: "04444" },
    { name: "Bangor", zips: "04401" },
    { name: "Winterport", zips: "04496" },
    { name: "Newburgh", zips: "04444" },
    { name: "Orrington", zips: "04474" },
    { name: "Holden", zips: "04429" },
    { name: "Brewer", zips: "04412" },
    { name: "Old Town", zips: "04468" },
    { name: "Orono", zips: "04473" },
    { name: "Veazie", zips: "04401" },
    { name: "Hermon", zips: "04401" },
    { name: "Kenduskeag", zips: "04450" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Hampden departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Fast passport renewal in Bangor", route: "/bangor" },
    { name: "Emergency passport help in Orono", route: "/orono" },
    { name: "Urgent passport services in Old Town", route: "/old-town" },
    { name: "Same-day passport help in Brewer", route: "/brewer" },
    { name: "Expedited passport services in Augusta", route: "/augusta-me" },
    { name: "Passport courier services in Lewiston", route: "/lewiston" },
    { name: "Rush passport help in Portland", route: "/portland-me" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Hampden, Maine remotely via secure courier. We do not have a walk-in office in Hampden — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Hampden travelers.",
  fpcOfficeAddress: "One Boston Place, #2600, Boston, MA 02108",
  fpcOfficeDistance: "Serving the greater Hampden and Bangor area",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Hampden and the greater Bangor region. From the quiet suburban neighborhoods of Hampden to the nearby Penobscot River towns of Winterport, Newburgh, and Orrington — we help Hampden travelers get their passports fast, often in 24–48 hours through our registered courier service.",
  nearbyCitiesIntro: "We serve all Hampden neighborhoods and nearby towns including Bangor, Winterport, Newburgh, Orrington, Holden, Brewer, Old Town, Orono, Veazie, Hermon, and Kenduskeag.",
  howItWorksIntro: "Most Hampden travelers complete everything online and ship documents overnight. No need to drive to Boston or Portland. Our emergency and expedited passport process is designed for Maine travelers who need fast, reliable results.",
  mistakesIntro: "Hampden residents often commute to Bangor for work or travel through Bangor International Airport for flights. Residents and families often need passports at short notice. Here are the most common mistakes we see from Hampden-area travelers.",
  testimonialsIntro: "Hampden and Bangor area travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Hampden? Here are the most common ones we hear from Penobscot County travelers.",
  statePageRoute: "/states/maine",
  statePageName: "Maine",
  dmvWebsite: "https://www.maine.gov/sos/bmv",
  dmvLabel: "Maine BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Hampden international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Sarah K.",
      location: "Hampden, ME",
      rating: 5,
      text: "My passport expired 3 days before our family trip to Ireland. Fast Passport Center got my renewal done in 48 hours. I shipped from Hampden and had it back in time. Absolutely amazing service.",
      service: "Passport Renewal",
    },
    {
      name: "James T.",
      location: "Winterport, ME",
      rating: 5,
      text: "Emergency business trip to Toronto with 72 hours notice. Fast Passport Center had my emergency passport ready in 36 hours. I dropped off at the Bangor UPS Store and had it back the next day.",
      service: "Emergency Passport",
    },
    {
      name: "Michelle R.",
      location: "Bangor, ME",
      rating: 5,
      text: "Lost my passport right before our cruise out of Boston. Fast Passport Center handled the DS-64 form and had my replacement ready in 3 days. They coordinated the acceptance clerk visit at the Bangor Post Office.",
      service: "Lost Passport",
    },
    {
      name: "Robert H.",
      location: "Orrington, ME",
      rating: 5,
      text: "Passport renewal for our daughter's school trip to Quebec. Fast Passport Center helped us navigate the process and got the passport in 5 days. The shipping from the Bangor area was easy.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "hampden-1",
      name: "Bangor Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 Ohio St",
      city: "Bangor",
      state: "ME",
      zip: "04401",
      phone: "(207) 945-4574",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "6 miles from Hampden",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main passport acceptance facility for the Bangor area. Largest facility in the region with most appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "hampden-2",
      name: "Hampden Town Office",
      type: "Municipal Passport Acceptance",
      address: "106 Western Ave",
      city: "Hampden",
      state: "ME",
      zip: "04444",
      phone: "(207) 862-3034",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "In Hampden",
      website: "https://www.hampdenmaine.com/",
      websiteLabel: "Hampden Town Office",
      notes: "Town clerk services. Call ahead to confirm passport acceptance hours and appointment availability.",
      icon: "ri-government-line",
    },
    {
      id: "hampden-3",
      name: "Brewer Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "400 Wilson St",
      city: "Brewer",
      state: "ME",
      zip: "04412",
      phone: "(207) 989-4555",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles from Hampden",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient option for Brewer and Hampden residents across the Penobscot River.",
      icon: "ri-mail-line",
    },
    {
      id: "hampden-4",
      name: "Orono Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 College Ave",
      city: "Orono",
      state: "ME",
      zip: "04473",
      phone: "(207) 866-2561",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles from Hampden",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "University of Maine area. Good option for Orono and Veazie residents.",
      icon: "ri-mail-line",
    },
    {
      id: "hampden-5",
      name: "Old Town Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "141 Center St",
      city: "Old Town",
      state: "ME",
      zip: "04468",
      phone: "(207) 827-6151",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles from Hampden",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Northern Penobscot County option. Backup for Hampden area.",
      icon: "ri-mail-line",
    },
    {
      id: "hampden-6",
      name: "Orrington Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "209 Center Dr",
      city: "Orrington",
      state: "ME",
      zip: "04474",
      phone: "(207) 825-4314",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles from Hampden",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Closest USPS option to Hampden. Small facility — call ahead for appointments.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive to Boston", fpc: "No — ship from home" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Local Hampden photo shops may use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Hampden acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Hampden applicants show up with incorrect checks and have to reschedule.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Hampden families.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Hampden travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location near Hampden." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Hampden address — trackable every step of the way." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Hampden, Maine?",
      a: "Fast Passport Center offers emergency passport processing in Hampden in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, bypassing standard mail delays.",
    },
    {
      q: "Can I get a same-day passport in Hampden, Maine?",
      a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option.",
    },
    {
      q: "Where can I get a fast passport renewal in Hampden, Maine?",
      a: "Fast Passport Center offers fast passport renewal in Hampden with no office visit required. Simply complete your application online, ship your documents using our prepaid overnight label, and our couriers handle the rest.",
    },
    {
      q: "How far is Hampden from the Boston Passport Agency?",
      a: "Hampden is approximately 110 miles from the Boston Passport Agency — about a 2-hour drive. With Fast Passport Center, you avoid that trip entirely.",
    },
    {
      q: "What acceptance facilities are near Hampden, Maine?",
      a: "Options near Hampden include the Bangor Post Office (04401), Hampden Town Office (04444), Orrington Post Office (04474), Brewer Post Office (04412), and Orono Post Office (04473). The Bangor Post Office is the largest facility with most appointment availability.",
    },
    {
      q: "Do I need to visit the Boston Passport Agency?",
      a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery.",
    },
    {
      q: "Is Hampden close to Bangor International Airport?",
      a: "Yes, Bangor International Airport (BGR) is only about 6 miles from Hampden — roughly 10 minutes away. It's the closest airport for Hampden travelers with direct flights to major hubs.",
    },
    {
      q: "How much does expedited passport service cost in Hampden?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed. Contact us for a quote.",
    },
    {
      q: "What documents do I need for a first-time passport in Hampden?",
      a: "You'll need proof of citizenship, government-issued photo ID, two passport photos, and payment. We provide a complete checklist and review your documents.",
    },
    {
      q: "Can you help with a child's passport in Hampden?",
      a: "Yes. Child passports require both parents (or notarized consent), the child's birth certificate, and both parents' IDs. We walk Hampden families through the process.",
    },
    {
      q: "Is there a UPS Store near Hampden for shipping documents?",
      a: "Yes, there's a UPS Store in Bangor near the airport. We provide a prepaid overnight label. The Bangor Post Office on Ohio St also accepts packages.",
    },
    {
      q: "Can I get passport photos taken in Hampden?",
      a: "Yes, CVS and Rite Aid in Bangor offer passport photo services. The Walgreens and CVS in Brewer are also convenient options. The Hampden Town Office may also offer photo services — call ahead.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Bangor", address: "639 Broadway, Bangor, ME 04401", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator/cvs-pharmacy-locations" },
    { name: "Walgreens — Bangor", address: "617 Broadway, Bangor, ME 04401", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/store-locator" },
    { name: "Rite Aid — Bangor", address: "90 Union St, Bangor, ME 04401", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/locations" },
    { name: "CVS Pharmacy — Brewer", address: "401 Wilson St, Brewer, ME 04412", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator/cvs-pharmacy-locations" },
    { name: "Walmart Photo Center — Bangor", address: "900 Stillwater Ave, Bangor, ME 04401", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walmart.com/store/finder" },
    { name: "Rite Aid — Old Town", address: "141 Center St, Old Town, ME 04468", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/locations" },
    { name: "CVS Pharmacy — Orono", address: "1 College Ave, Orono, ME 04473", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator/cvs-pharmacy-locations" },
    { name: "Walgreens — Orono", address: "12 Mill St, Orono, ME 04473", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/store-locator" },
  ],
  dmvLocations: [
    {
      name: "BMV — Bangor",
      address: "199 Hogan Rd, Bangor, ME 04401",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Full-service BMV. 6 miles from Hampden. Online appointment booking available.",
      featured: true,
    },
    {
      name: "BMV — Old Town",
      address: "141 Center St, Old Town, ME 04468",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Penobscot County option. 12 miles from Hampden.",
      featured: false,
    },
    {
      name: "BMV — Augusta",
      address: "29 State House Station, Augusta, ME 04333",
      hours: "Mon–Fri: 8AM–5PM",
      note: "State capital full-service BMV. 55 miles from Hampden.",
      featured: false,
    },
    {
      name: "BMV — Ellsworth",
      address: "170 High St, Ellsworth, ME 04605",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Hancock County option. 40 miles from Hampden.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "BGR",
      name: "Bangor International Airport",
      distance: "6 miles from Hampden (10 min)",
      address: "2870 Godfrey Blvd, Bangor, ME 04401",
      note: "Maine's second busiest airport and closest to Hampden. Direct flights to Boston, New York, Philadelphia, and seasonal international connections. The best option for Hampden travelers.",
      flightUrl: "https://www.flybangor.com/",
      flightLabel: "Bangor Airport",
      featured: true,
    },
    {
      code: "PWM",
      name: "Portland International Jetport",
      distance: "130 miles from Hampden (2 hours)",
      address: "1001 Westbrook St, Portland, ME 04102",
      note: "Maine's busiest airport with more flight options. Alternative for Hampden travelers willing to drive south.",
      flightUrl: "https://www.portlandjetport.org/",
      flightLabel: "PWM Flight Info",
      featured: false,
    },
    {
      code: "BOS",
      name: "Logan International Airport",
      distance: "110 miles from Hampden (2 hours)",
      address: "1 Harborside Dr, Boston, MA 02128",
      note: "Major international hub with direct flights to Europe, Asia, and Latin America. Many Hampden travelers drive to Boston for international travel.",
      flightUrl: "https://www.massport.com/logan-airport",
      flightLabel: "Logan Airport",
      featured: false,
    },
  ],
};